export default __webpack_public_path__ + "static/media/empty-plate.877ab7b0.png";